var map = {
	"./404.svg": 975,
	"./Categories.png": 724,
	"./Edit-menu.svg": 976,
	"./Egg.svg": 977,
	"./Emaier-Header.png": 978,
	"./Qr-4.png": 979,
	"./_duplicate.svg": 980,
	"./_overview.svg": 981,
	"./add-white.svg": 982,
	"./alert.svg": 983,
	"./all_category.svg": 984,
	"./archive.svg": 985,
	"./armchair.svg": 986,
	"./arrow-circle-right.svg": 987,
	"./arrow-left-circle.svg": 988,
	"./arrow-right-circle.svg": 989,
	"./arrow-right.svg": 990,
	"./asc-up-white.svg": 991,
	"./asc.png": 992,
	"./asc.svg": 993,
	"./back-arrow.svg": 994,
	"./barcode-icon.svg": 995,
	"./beverages.svg": 996,
	"./blue-edit-pen.svg": 997,
	"./blue-eye.svg": 998,
	"./box-office.svg": 999,
	"./broken-seat.jpg": 1000,
	"./calendar_list.svg": 1001,
	"./calender.svg": 369,
	"./chevron-down.svg": 1002,
	"./chevron-left.svg": 1003,
	"./cinema-mamagement-sidebar.svg": 1004,
	"./claendar.svg": 317,
	"./clock-1.svg": 1005,
	"./clock.svg": 1006,
	"./close-button.svg": 731,
	"./close-white.svg": 738,
	"./close-x.svg": 312,
	"./collapse-up.svg": 1007,
	"./collapse.svg": 1008,
	"./connection-lost.svg": 367,
	"./consumable-raw-material.svg": 1009,
	"./copy.svg": 1010,
	"./copy_image_icon.png": 1011,
	"./delete-red-light.svg": 1012,
	"./delete-red.svg": 739,
	"./delete.svg": 712,
	"./deliver-icon.svg": 1013,
	"./desc-down-white.svg": 1014,
	"./desc.svg": 1015,
	"./distributors-sidebar.svg": 1016,
	"./download.svg": 1017,
	"./dragndrop.svg": 1018,
	"./dragndrop2.svg": 1019,
	"./duplicate.svg": 1020,
	"./duplicateScreen.svg": 1021,
	"./e-wallet-icon-black.svg": 1022,
	"./edit-pen-blue.svg": 1023,
	"./edit-pen-white.svg": 1024,
	"./edit-pen.svg": 1025,
	"./edit.svg": 1026,
	"./email.png": 1027,
	"./empty-image.svg": 1028,
	"./excel.svg": 1029,
	"./external-link.svg": 1030,
	"./eye.svg": 1031,
	"./filter-icon.svg": 1032,
	"./flag.svg": 1033,
	"./fnb-app-order.svg": 1034,
	"./fnb-beverages.svg": 1035,
	"./fnb-brownie.svg": 1036,
	"./fnb-combo.svg": 1037,
	"./fnb-desert.svg": 1038,
	"./fnb-eatables.svg": 1039,
	"./fnb-make-your-combo.svg": 1040,
	"./fnb-popcorn.svg": 1041,
	"./fnbtransactionIcon.svg": 1042,
	"./fullscreen-icon.svg": 740,
	"./funnel.svg": 1043,
	"./globe.svg": 1044,
	"./green-tick.svg": 1045,
	"./grid-view.svg": 1046,
	"./hide-password.svg": 370,
	"./home-icon.svg": 1047,
	"./home.svg": 1048,
	"./icon-black-play.svg": 1049,
	"./icon-dot.svg": 1050,
	"./icon-fnb.svg": 1051,
	"./icon-marketing.svg": 1052,
	"./icon-no-seat.png": 1053,
	"./icon-no-seat.svg": 1054,
	"./icon-option.svg": 1055,
	"./icon-poin-of-sale.svg": 1056,
	"./icon-recliner.svg": 1057,
	"./icon-report.svg": 1058,
	"./icon-sofa-dark-1.svg": 1059,
	"./icon-sofa-dark.png": 1060,
	"./icon-sofa-dark.svg": 1061,
	"./icon-sofa.svg": 1062,
	"./importfile.svg": 1063,
	"./info.svg": 741,
	"./info2.svg": 1064,
	"./keyboard-icon.svg": 1065,
	"./kitchen_display.svg": 1066,
	"./language-icon.svg": 371,
	"./left-caret.svg": 1067,
	"./link.svg": 1068,
	"./list-view.svg": 1069,
	"./loading.svg": 372,
	"./lock.svg": 1070,
	"./login-password.png": 373,
	"./login-user.png": 374,
	"./logout.svg": 742,
	"./masters-sidebar.svg": 1071,
	"./merchandise.svg": 1072,
	"./minus.svg": 1073,
	"./movie-pass-svg.svg": 722,
	"./movie-rolling.svg": 1074,
	"./mulitSchedule.svg": 1075,
	"./multicurrency.svg": 1076,
	"./multifnb.svg": 1077,
	"./nav-plus.svg": 1078,
	"./new_filter_icon.svg": 1079,
	"./no-image.svg": 1080,
	"./no-schedule.svg": 144,
	"./non-veg-mark.png": 1081,
	"./non-veg-mark.svg": 1082,
	"./notification.svg": 1083,
	"./open-link-blue.svg": 1084,
	"./openPlanned.svg": 1085,
	"./overview.svg": 1086,
	"./overview2.svg": 1087,
	"./pdf-icon.svg": 1088,
	"./pdf.svg": 1089,
	"./pickup-ticket-icon.svg": 1090,
	"./pickupfnb.svg": 1091,
	"./play.svg": 1092,
	"./plus.svg": 1093,
	"./pointofsale-1.svg": 1094,
	"./pointofsale-2.svg": 1095,
	"./pointofsale.png": 1096,
	"./portfolio.svg": 1097,
	"./pos-fnb-no-itmes.svg": 725,
	"./pos-refresh.svg": 1098,
	"./primary/chevron-down.svg": 1099,
	"./primary/download.svg": 1100,
	"./primary/edit.svg": 1101,
	"./primary/filter.svg": 1102,
	"./primary/printer.svg": 1103,
	"./print-icon.svg": 1104,
	"./print.svg": 1105,
	"./question.svg": 1106,
	"./question1.svg": 1107,
	"./question2.svg": 743,
	"./question3.svg": 1108,
	"./recliner-1.svg": 1109,
	"./recliner.png": 1110,
	"./refund-icon.svg": 1111,
	"./reload-icon-pos.svg": 1112,
	"./reload-icon.svg": 1113,
	"./restore.svg": 1114,
	"./right-caret.svg": 1115,
	"./role-management-sidebar.svg": 1116,
	"./save.svg": 1117,
	"./schedule-icon.svg": 1118,
	"./school-calendar.svg": 1119,
	"./search-global-white.svg": 1120,
	"./search-global.svg": 1121,
	"./search.svg": 744,
	"./searchIcon.svg": 1122,
	"./seat-icon-2.svg": 1123,
	"./seat-icon.svg": 1124,
	"./seat-icons/3-wheelChair.png": 1125,
	"./seat-icons/block_seat_new.png": 1126,
	"./seat-icons/broken-seat-1.svg": 1127,
	"./seat-icons/broken-seat-2.svg": 1128,
	"./select-food.png": 745,
	"./settings.svg": 1129,
	"./show-password.svg": 375,
	"./slider-triangle.svg": 734,
	"./snack.svg": 746,
	"./sort.svg": 1130,
	"./star-empty.svg": 1131,
	"./star-fill.svg": 1132,
	"./success-tick.svg": 1133,
	"./suitcase.svg": 1134,
	"./swap.svg": 1135,
	"./tick-green-item.svg": 747,
	"./tick-green.svg": 1136,
	"./ticket-icon.svg": 1137,
	"./trash.svg": 1138,
	"./unpaid-reservation.svg": 716,
	"./updown-white.svg": 1139,
	"./updown.svg": 1140,
	"./user-attribute.svg": 1141,
	"./user-attributes.svg": 1142,
	"./user-female.svg": 1143,
	"./user-male-white.svg": 1144,
	"./user-male.svg": 1145,
	"./user-profile.svg": 1146,
	"./userProfile.png": 1147,
	"./veg-food-mark-white.png": 1148,
	"./veg-foog-mark-trans.png": 1149,
	"./view.png": 1150,
	"./view.svg": 1151
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 974;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons ^\.\/.*$
// module id = 974
// module chunks = 38